import React from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const Search = ({ handleSearchNote }) => {
  return (
    <div className="search">
      <SearchOutlinedIcon className="search-icons" size="1.3em" />
      <input
        onChange={(event) => handleSearchNote(event.target.value)}
        type="text"
        placeholder="type to search..."
      />
    </div>
  );
};

export default Search;
